// extracted by mini-css-extract-plugin
export default {"mainContainer":"TagSelector_mainContainer__Oj8hY"};